module.exports = __webpack_public_path__ + "static/sharanaprada-e780d3a1e7502ebef5e12fda282624df.jpg";